module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門3_9.65fb2392.png";